import classNames from "classnames";
import { toStateClass } from "../../../utils/toStateClass.js";
import { toEnumClass } from "../../../utils/toEnumClass.js";
import { toThemeClass } from "../../../utils/toThemeClass.js";
import { toEnumViewClass } from "../../../utils/toEnumViewClass.js";
import { toEnumStateClass } from "../../../utils/toEnumStateClass.js";
function useInputClassName({
  active,
  disabled,
  loading,
  readOnly,
  required,
  focused,
  hovered,
  className: outerClassName,
  distinction,
  intent,
  scheme,
  size,
  validationState,
  ...restNotImplemented
}) {
  let finalIntent = disabled ? "default" : intent;
  if (validationState === "invalid") {
    finalIntent = "danger";
  }
  return classNames(
    toStateClass("active", active),
    toStateClass("disabled", disabled),
    toStateClass("focused", focused),
    toStateClass("hovered", hovered),
    toStateClass("loading", loading),
    toStateClass("read-only", readOnly),
    toStateClass("required", required),
    toEnumClass("scheme-", !disabled ? scheme : void 0),
    toThemeClass(finalIntent, finalIntent),
    toEnumViewClass(size),
    toEnumViewClass(distinction),
    toEnumStateClass(validationState),
    outerClassName
  );
}
export {
  useInputClassName
};
//# sourceMappingURL=useInputClassName.js.map
